import * as React from "react";
import { useQuery } from "@apollo/client";
import { getAuth, signOut } from "firebase/auth";

import { ME } from "../graphql/me";
import Login from "../auth/Login";
import Button from "@mui/material/Button";
import MapPage from "../map-page/MapPage";
import VansPage from "../vans-page/VansPage";
import HomePage from "../home-page/HomePage";
import OrderPage from "../order-page/OrderPage";
import { Routes, Route } from "react-router-dom";
import InvetAppBar from "../invet-app-bar/InvetAppBar";
import EmployeePage from "../employee-page/EmployeePage";
import { UserRoles } from "../employee-page/user-roles.enum";
import WarehousesPage from "../warehouses-page/WarehousesPage";

export default function MainPage({ isAuth }) {
	const auth = getAuth();
	const { loading, error, data } = useQuery(ME);
	if (loading) {
		return <div>Loading me...</div>;
	}
	if (!isAuth) {
		return (
			<>
				<Login />
			</>
		);
	}
	if (data.me.role !== UserRoles.ADMIN && data.me.role !== UserRoles.MANAGER) {
		return (
			<>
				<div>You're not admin or manager.</div>
				<Button variant="outlined" onClick={() => signOut(auth)}>
					Sign out
				</Button>
			</>
		);
	}
	return (
		<div>
			<InvetAppBar authScope={data.me.role} />
			<>
				<Routes>
					<Route path="/" element={<HomePage />}>
						{(data.me.role === UserRoles.ADMIN ||
							data.me.role === UserRoles.MANAGER) && (
							<>
								<Route
									path="orders"
									element={<OrderPage authScope={data.me.role} />}
								/>
								<Route path="map" element={<MapPage />} />
							</>
						)}
						{data.me.role === UserRoles.ADMIN && (
							<>
								<Route path="employee" element={<EmployeePage />} />
								<Route path="warehouses" element={<WarehousesPage />} />
								<Route path="vans" element={<VansPage />} />
							</>
						)}
					</Route>
				</Routes>
			</>
		</div>
	);
}
